import {
  SET_SUPPORT_ADDON_FIELD,
  SET_SUPPORT_ADDON_PRICE_FIELD,
  SET_SOFTWARE_PRODUCT_FIELD,
  SET_SOFTWARE_PRODUCT_PRICE_FIELD,
  TOGGLE_SUPPORT_ADDON,
  TOGGLE_ENABLED_CURRENCY,
  SET_ERRORS,
  SET_SOFTWARE_PRODUCT,
  SET_SOFTWARE_PRICES,
} from './constants';

import {moduleNamespace as addonManagerModuleNamespace} from '../addonManager/constants';

import {validateSoftwareProduct} from "./schema/product";
import {validateSupportAddon} from "./schema/supportAddon";

import Swal from 'sweetalert2';

function setLoadingState({ commit }, boolean) {
  commit('SET_LOADING_STATE', boolean);
}

/**
 * Fetch resellable software products from the server.
 */
export function fetchSoftwarePrices({ commit }) {
  return axios.get('/merchant/software-prices') // TODO: Consider module axios promises, generally
    .then(({ data }) => {
      commit(SET_SOFTWARE_PRICES, data);
    })
    .catch(e => {
      Swal.fire({
        icon: 'error',
        text: 'An unknown error occurred, please contact support@hikeseo.co',
      });
    });
}

/**
 * Store the modifications to the product and support addon to the database.
 */
export function updateProductAndSupportAddon({getters}) {
  let {supportedCurrencies, softwareProduct, supportAddon} = getters;

  let enabledCurrencies = [];
  Object.entries(supportedCurrencies).forEach(([currencyCode, {enabled}]) => {
    if (enabled) {
      enabledCurrencies.push(currencyCode);
    }
  });

  let {prices, ...product} = softwareProduct;
  const software = {
    prices,
    ...product,
  };

  let payload = {
    enabledCurrencies,
    software,
  };

  ({prices, ...product} = supportAddon);
  const support = {
    prices,
    ...product,
  };

  if (getters.enableSupportAddon) {
    payload = {...payload, support};
  }

  return axios.post('/merchant/update-software-product', payload);
}

/**
 * Clear all pricing related errors, used prior on successful product validation
 */
export function clearPricingErrors(state) {
  delete state.errors[`softwareProduct.prices`];
  delete state.errors[`supportAddon.prices`];

  Object.entries(state.supportedCurrencies).forEach(([currencyCode]) => {
    delete state.errors[`softwareProduct.prices.${currencyCode}.monthlyRaw`];
    delete state.errors[`softwareProduct.prices.${currencyCode}.annualRaw`];

    delete state.errors[`supportAddon.prices.${currencyCode}.monthlyRaw`];
    delete state.errors[`supportAddon.prices.${currencyCode}.annualRaw`];
  });
}

export default {
  fetchSoftwarePrices,
  updateProductAndSupportAddon,
  setLoadingState,
  setSoftwareProduct: ({commit}, payload) => commit(SET_SOFTWARE_PRODUCT, payload),
  setSupportAddonField: ({commit}, payload) => commit(SET_SUPPORT_ADDON_FIELD, payload),
  setSupportAddonPriceField: ({commit}, payload) => commit(SET_SUPPORT_ADDON_PRICE_FIELD, payload),
  setSoftwareProductField: ({commit}, payload) => commit(SET_SOFTWARE_PRODUCT_FIELD, payload),
  setSoftwareProductPriceField: ({commit}, payload) => commit(SET_SOFTWARE_PRODUCT_PRICE_FIELD, payload),
  toggleSupportAddon: ({commit}, payload) => commit(TOGGLE_SUPPORT_ADDON, payload),
  toggleEnabledCurrency: ({commit}, payload) => commit(TOGGLE_ENABLED_CURRENCY, payload),
  setErrors: ({commit}, payload) => commit(SET_ERRORS, payload),
  validateSoftwareProduct: ({commit, state, getters}) => new Promise((resolve, reject) => {
    const errors = validateSoftwareProduct(state, getters);
    if (errors) {
      commit(SET_ERRORS, {
        errors: errors.details,
        namespace: 'softwareProduct',
        joi: true
      });
      reject(errors);
      return;
    }

    clearPricingErrors(state);
    resolve();
  }),
  validateSupportAddon: ({commit, state, getters}) => new Promise((resolve, reject) => {
    const errors = validateSupportAddon(state, getters);

    if (errors && state.enableSupportAddon) {
      commit(SET_ERRORS, {
        errors: errors.details,
        namespace: 'supportAddon',
        joi: true
      });
      reject(errors);
      return;
    }
    resolve();
  }),
};
